import { useEffect, useState, useContext, useRef} from 'react'
import Fetch, { GET } from '../inc/Fetch';


export default function MoeLogin() {

    const [data, setdata] = useState({})

    async function loadData() {
        let res = await GET(`moeLogin`);
        console.log(res);
        
        setdata(res);
    }


    useEffect(() => {
        loadData();
    }, []);

    return (<>
        <div style={{ padding:20, direction:'ltr', margin:'auto', width:500, border:'1px solid black'}}>{JSON.stringify(data)}</div>
    </>);


}
